module.exports = __webpack_public_path__ + "img/bg_space_tr5.69a8b12b.png";